// param name to group relation

export default {
  CP: [
    'ID.depend',
    'ScheduleID',
    'Cotir.def.param.group.ID',
    'BidUncrossOffset',
    'AskUncrossOffset',
    'VolumeWeight',
    'NoVolumePenalty',
    'D.Spread',
    'NormalSpread',
    'QuoteVolume',
    'D_oc',
    'GO.HardOpen',
    'moveVol',
    'movePrice',
    'eLimitedMargin',
    'BUY',
    'SprOpen',
    'SprClose',
    'StepPos',
    'StepSpread',
    'NoShiftLimit',
    'LimitBuy',
    'SELL',
    'SprOpen',
    'SprClose',
    'StepPos',
    'StepSpread',
    'NoShiftLimit',
    'LimitSell',
    'HEDGING',
    'IsHedgeble',
    'Priority',
    'MinPos',
    'OrderVol',
    'PriceDistance',
    'SpreadCoefDistance',
    'UseTeorPrices',
    'HedgeInstId'
  ],
  SP: [
    'ID.source',
    'Source.def.par.group.ID',
    'DealsWindow..sec.',
    'DealsVolRecalcShare',
    'Currency',
    'ShortBonus',
    'NotTradable',
    'Factor',
    'Beta',
    'BaseInstr'
  ],
  MDP: [
    'SheduleID',
    'ID.depend',
    'ID.source',
    'Source.Type',
    'Source.type.shedule.ID'
  ]
}